import { tuApptoAPI, getAuthHeaders, getErrorData } from './config'

const headers = getAuthHeaders().headers
export const findAll = async id => {
  try {
    const response = await tuApptoAPI.get(`/personnel/findall/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const findAllLicenseType = async id => {
  try {
    const response = await tuApptoAPI.get(`/personnel/license/findallTypes/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const create = async request => {
  try {
    const response = await tuApptoAPI.post('/personnel/create', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const createLicenseType = async request => {
  try {
    const response = await tuApptoAPI.post('/personnel/license/type/create', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const deleteLicenseType = async request => {
  try {
    const response = await tuApptoAPI.post('/personnel/license/type/delete', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const update = async request => {
  try {
    const response = await tuApptoAPI.put('/personnel/update', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const status = async request => {
  try {
    const response = await tuApptoAPI.put('/personnel/status', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const records = async request => {
  try {
    const response = await tuApptoAPI.post('/personnel/records', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}
